import { required, minLength, maxLength } from '@vuelidate/validators'
import { noMaliciousPatterns, isValidForXML } from '@/validations/validators'

export const nameUnit = {
  required,
  minLength: minLength(2),
  maxLength: maxLength(32),
  noMaliciousPatterns,
  isValidForXML
}
